<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "EmployeeDetailsView"
    }
</script>

<style scoped>

</style>